import React from 'react';
import cn from 'classname';
import './index.less';

import withIntl from '../../../../../shared/intl-hoc';

function Legend({ className, intl, list }) {
	return (
		<div className={cn('analytics-legend', className)}>
			<div className='analytics-legend-title font-proxima-nova-bold'>
				{intl('Возраст')}
			</div>
			<ul className='analytics-legend-list'>
				{list.map(({ title, color }, i) => (
					<li
						className='analytics-legend-item'
						key={i}
					>
						<div
							className='analytics-legend-item-square'
							style={{
								background: color
							}}
						/>
						<div className='analytics-legend-item-title'>
							{intl(title)}
						</div>
					</li>
				))}
			</ul>
		</div>
	);
}

export default withIntl(Legend);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/info/components/Analytics/Legend/index.js